<script setup lang="ts">
import { cn } from '@/helpers/cn';
import type { ButtonHTMLAttributes } from 'vue';

interface Props extends /* @vue-ignore */ ButtonHTMLAttributes {
  variant?: 'primary' | 'secondary' | 'tertiary';
  disabled?: boolean;
  loading?: boolean;
  class?: string | string[];
}

type Emits = {
  click: [payload: MouseEvent];
};

const { variant = 'primary', ...props } = defineProps<Props>();
const emits = defineEmits<Emits>();
</script>

<template>
  <button
    v-bind="props"
    :class="
      cn([
        'disabled:opacity-50 h-9 text-nowrap px-5 py-[10px] text-sm leading-none',
        variant === 'primary' && [
          'rounded-full bg-af-pink-500 text-white font-medium min-w-[120px]',
          'hover:bg-af-pink-600 transition-colors duration-300 disabled:hover:bg-af-pink-500',
        ],
        variant === 'secondary' && [
          'rounded-full border border-af-grey-500! bg-af-white text-af-grey-700 min-w-[120px]',
          'hover:bg-af-grey-300! hover:border-transparent! transition-colors duration-300',
        ],
        variant === 'tertiary' && [
          'px-5 py-[10px] bg-af-white font-medium text-af-grey-700 underline underline-offset-2 rounded-full',
          'hover:no-underline  transition-colors duration-300',
        ],
        props.class,
      ])
    "
    :disabled="props.disabled || props.loading"
    @click="emits('click', $event)"
  >
    <VIcon v-if="loading" icon="fas fa-spinner-third" class="animate-spin" size="16" />
    <slot v-else />
  </button>
</template>
